import { ProtectedRoute } from "@/components/ProtectedRoute";
import { createFileRoute } from "@tanstack/react-router";
import { ProjectDraftsPage } from "../../../../pages/project/ProjectDraftsPage";

export const Route = createFileRoute("/admin/project/$projectId/drafts")({
  component: ProtectedProjectDraftsPage,
});

function ProtectedProjectDraftsPage() {
  return (
    <ProtectedRoute>
      <ProjectDraftsPage />
    </ProtectedRoute>
  );
}
